import React, { Component } from 'react';
import EffectParameterSlider from 'components/effects/EffectParameterSlider.js';
import OscillatorOption from './OscillatorOption.js';
import OscillatorComponent from './OscillatorComponent.js';
import Dropdown from 'react-dropdown'

class OscillatorsComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
        };
    }

    render() {
        let instrument = this.props.instrument;
        let oscillator = this.props.instrument.getOscillator(this.props.selectedOscillator);
        return (
            <div className="oscillators-component">
              <div className="oscillator-subsection-header">
                <div className="instrument-subsection-name">
                  Oscillator
                </div>
                <div className="oscillator-options">
                  <OscillatorOption
                    sequencerEngine={this.props.sequencerEngine}
                    selectedOscillator={this.props.selectedOscillator}
                    oscillator={instrument.getOscillator(0)}
                    number={0}
                    onChooseOscillator={(x) => this.props.onChooseOscillator(x)}/>
                  <OscillatorOption
                    sequencerEngine={this.props.sequencerEngine}
                    selectedOscillator={this.props.selectedOscillator}
                    oscillator={instrument.getOscillator(1)}
                    number={1}
                    onChooseOscillator={(x) => this.props.onChooseOscillator(x)}/>
                  <OscillatorOption
                    sequencerEngine={this.props.sequencerEngine}
                    selectedOscillator={this.props.selectedOscillator}
                    oscillator={instrument.getOscillator(2)}
                    number={2}
                    onChooseOscillator={(x) => this.props.onChooseOscillator(x)}/>
                  <OscillatorOption
                    sequencerEngine={this.props.sequencerEngine}
                    selectedOscillator={this.props.selectedOscillator}
                    oscillator={instrument.getOscillator(3)}
                    number={3}
                    onChooseOscillator={(x) => this.props.onChooseOscillator(x)}/>
                </div>
              </div>
              <OscillatorComponent
                sequencerEngine={this.props.sequencerEngine}
                oscillator={oscillator} instrument={instrument}/>

            </div>
        );
    }
}



export default OscillatorsComponent;
